import { Pencil, Undo2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { StatusBadge } from '../../components/ui/common';
import type { ReferenceData } from '../../lib/api';
import { date } from '../../lib/format';
import type { ActionRecord } from './action-record';
import './action-details.css';

export function ActionRegister({ actions, reference, canEdit, onDetails, onReview, onEdit, onReverse }: {
  actions: ActionRecord[]; reference?: ReferenceData; canEdit: boolean;
  onDetails: (action: ActionRecord) => void; onReview: (action: ActionRecord) => void;
  onEdit: (action: ActionRecord) => void; onReverse: (action: ActionRecord) => void;
}) {
  return <div className="table-scroll"><table className="action-register"><thead><tr><th>Security</th><th>Event</th><th>Unit-change date</th><th>Ratio / change</th><th>Rounding</th><th>Status</th><th>Review</th></tr></thead>
    <tbody>{actions.map(action => {
      const symbol = action.security?.symbol ?? reference?.securities.find(item => item.id === action.securityId)?.symbol ?? action.securityId;
      return <tr key={action.id} onClick={() => onDetails(action)}>
        <td><button type="button" className="action-event-link" aria-label={`View event details for ${symbol}, ${action.type.replaceAll('-', ' ')}, ${date(action.effectiveDate)}`} onClick={event => { event.stopPropagation(); onDetails(action); }}>{symbol}</button></td>
        <td>{action.type.replaceAll('-', ' ')}</td><td>{date(action.effectiveDate)}</td>
        <td>{action.type === 'split' || action.type === 'consolidation' ? `${action.oldUnits} old → ${action.newUnits} new` : action.type === 'rename' ? action.newName ?? action.newSymbol : `${action.cashPerOldUnit} per unit`}</td>
        <td>{action.rounding ?? '—'}</td><td><StatusBadge status={action.status} /></td>
        <td><div className="button-row" onClick={event => event.stopPropagation()}><Button variant="outline" size="sm" onClick={() => onReview(action)}>Review impact</Button>
          {canEdit && action.status === 'draft' && <Button size="icon" variant="ghost" aria-label="Edit draft action" onClick={() => onEdit(action)}><Pencil size={16} /></Button>}
          {canEdit && action.status === 'posted' && <Button size="icon" variant="ghost" aria-label="Reverse corporate action" onClick={() => onReverse(action)}><Undo2 size={16} /></Button>}
        </div></td>
      </tr>;
    })}</tbody>
  </table></div>;
}
